import styled from 'styled-components';

export const StyledCoinPriceCol = styled.td`
    font-weight: 500;
    font-size: 16px;
    color: ${({ theme }) => theme.trow.font};
`